<template>
  <banner-dialog v-if="showBanner" type="success" :dismissible="false">
    <span>More funds have been added to your account; click&nbsp;<em>Activate Account</em></span>
    <span>&nbsp;to start receiving leads now or&nbsp;</span>
    <router-link :to="{ name: 'client_account', params: { clientId, tab: 'pause' } }">
      set a vacation pause
    </router-link>
    <span>&nbsp;</span>
    <el-tooltip placement="right-end">
      <template #content>
        To set a vacation:<br />
        1. Visit Profile / Account Info, then select Pause near the top of the page. (or click the
        hyperlink to go there directly)<br />
        2. Click 'Add Pause.'<br />
        3. In the new window, click in the Pause Times field to set the start date/time and end
        date/time.<br />
        4. Click 'Save' to set the vacation pause.
      </template>
      <i class="fas fa-question-circle" />
    </el-tooltip>
    <span>&nbsp;until ready.</span>
    <el-button
      type="primary"
      style="margin-left: 8px"
      :loading="isActivating"
      @click="handleActivate"
    >
      Activate Account
    </el-button>
  </banner-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BannerDialog from '@/components/bannerDialog/BannerDialog.vue';

export default {
  name: 'ActivateBannerDialog',
  components: {
    BannerDialog,
  },
  data() {
    return {
      isActivating: false,
    };
  },
  computed: {
    ...mapGetters('client', ['clientId']),
    ...mapGetters('notifications', ['cashCapActivationNotifications']),
    showBanner() {
      return !!this.clientId && this.cashCapActivationNotifications.length > 0;
    },
  },
  methods: {
    ...mapActions('client', ['activateCashCapAccount']),
    async handleActivate() {
      this.isActivating = true;

      try {
        await this.activateCashCapAccount();
      } finally {
        this.isActivating = false;
      }
    },
  },
};
</script>
